module.exports = __webpack_public_path__ + "static/media/idle-rider-marker.94480050.svg";